import axios from 'axios';
import { url } from '../utils/api';
import setAuthToken from '../utils/setAuthToken';
import { setAlert } from './alert';
import {
    ADMIN_LOADED, AUTH_ERROR, GET_GUESTS, GUEST_ERROR, GUEST_LOADED, LOGIN_FAIL,
    LOGIN_SUCCESS, LOGOUT, REGISTER_FAIL, REGISTER_SUCCESS
} from './types';

// ------------------GUEST PART--------------------

// Load Guest
export const loadGuest = () => async dispatch => {
    if(localStorage.token){
        setAuthToken(localStorage.token);
    }
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Methods": "GET, PUT, POST"
            }
        }

        const res = await axios.get(`${url}/api/guests/me`, config);

        dispatch({
            type: GUEST_LOADED,
            payload: res.data
        });

    } catch (err) {
        dispatch({
            type: AUTH_ERROR
        });
    }
};


// Register Guest
export const guestRegister = ({ name, email, password }) => async dispatch => {
    const body = JSON.stringify({ name, email, password });
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Methods": "PUT,POST,DELETE"
            }
        }

        const res = await axios.post(`${url}/api/guests/register`, body, config);
        dispatch({
            type: REGISTER_SUCCESS,
            payload: res.data
        });

        dispatch(setAlert('Successfully Registered', 'success'));
        dispatch(loadGuest());
    } catch (err) {
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: REGISTER_FAIL
        });
    }
}

// Login Guest
export const guestLogin = ({ email, password }) => async dispatch => {
    const body = JSON.stringify({ email, password });
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
            }
        }

        const res = await axios.post(`${url}/api/guests/login`, body, config);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });

        dispatch(loadGuest());
        //dispatch(getMyApplication());
    } catch (err) {
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: LOGIN_FAIL
        });
    }
}


// Get Guests
export const getGuests = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/guests`, config);

        dispatch({
            type: GET_GUESTS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: GUEST_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}


// ------------------ADMIN PART--------------------

// Load Admin
export const loadAdmin = () => async dispatch => {
    if(localStorage.token){
        setAuthToken(localStorage.token);
    }
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Methods": "GET, PUT, POST"
            }
        }

        const res = await axios.get(`${url}/api/admin/me`, config);

        dispatch({
            type: ADMIN_LOADED,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: AUTH_ERROR
        });
    }
};

// Login Admin
export const adminLogin = ({ email, password }) => async dispatch => {
    const body = JSON.stringify({ email, password });
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
            }
        }

        const res = await axios.post(`${url}/api/admin/login`, body, config);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });

        dispatch(loadAdmin());
        dispatch(getGuests());
        //dispatch(getRooms());
        //dispatch(getApplications());
    } catch (err) {
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: LOGIN_FAIL
        });
    }
}

// LOGOUT
export const logout = () => dispatch => {
    dispatch({ type: LOGOUT });
    //dispatch({ type: CLEAR_USER});
};